import React from "react";
import * as moment from "moment";
import "./MyInvestmentModal.css";
import dots from "../../../../../assets/dots.svg";
// import angelaicon from "../../../../../assets/angelaicon.svg";
import { Util } from "./../../../../../../../../helpers/util";
import { useUser } from "../../../../../../../../hooks/use-user";
const MyInvestmentSilverPlan = ({ setPage, investment }) => {
  const { currency } = Util.getCurrency;
  const user = useUser();
  return (
    <div className="myinvestmentbody">
      <div className="myinvestment-main">
        <div className="header-flex">
          <h5 className="silvestinvestment-h5">
            {currency}
            {investment.package}
          </h5>
          <div
            onClick={() => setPage(1)}
            className="dots-main"
            style={{
              cursor: "pointer",
            }}
          >
            <img src={dots} alt="" className="dots-img" />
          </div>
        </div>
        <div>
          {/* <img src={angelaicon} alt="" /> */}
          <p
            style={{
              fontSize: "1.5em",
              color: "black",
              fontWeight: "bold",
            }}
          >
            Great Job {user.firstname} <span>😎</span>
          </p>
        </div>
        <div className="totalreturn-card mt-5">
          <div className="totalreturn-body">
            <p className="totalreturn-head">Total Balance</p>
            <p className="totalreturn-amount">
              {currency}
              {Util.formatMoneyNumber(investment.capital)}
            </p>
            {/* <p className="totalreturn-mini">0% portfoilo change today</p> */}
            <p className="amountreturned">Total Returns:</p>
            <p className="main-amount">
              {currency}

              {Util.formatMoneyNumber(investment.i_return)}
            </p>
          </div>
        </div>
        <p className="countdown-p mt-3">
          Countdown: <span>{investment.timeLeft}days</span>
        </p>
        <div className="silverplan">
          <h5 className="silverplan-header">{investment.package}</h5>
          <div className="silverplan-flex">
            <div className="investamount">
              <p className="flex-main">Investment Amount:</p>
              <p className="pricetag">
                {currency}
                {Util.formatMoneyNumber(investment.capital)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Duration:</p>
              <p className="flex-mini">
                {Math.round(investment.period / 30)} Months
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Start Date:</p>
              <p className="flex-mini">
                {moment(investment.date_invested).format("DD MMM, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Maturity Date:</p>
              <p className="flex-mini">
                {moment(investment.end_date).format("DD MMM, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Interest Rate:</p>
              <p className="pricetag">
                {(investment.i_return / investment.capital) * 100}% P/A
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Status:</p>
              <p className="matured-status">{investment.status}</p>
            </div>
            <div className="investamount">
              <p className="flex-mini">Total Payout:</p>
              <p className="pricetag-mini">
                {currency}
                {Util.formatMoneyNumber(
                  +investment.i_return + +investment.capital
                )}
              </p>
            </div>
          </div>
        </div>
        {investment.timeLeft === 0 && (
          <div className="totalreturn-note">
            <p className="little-note">
              Your Silvest Investment plan has been closed and deposited in your
              wallet for withdrawal or reinvestment.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyInvestmentSilverPlan;
